import { CheckIcon } from '../icons/ControlIcons';

/**
 * One filter option, as a toggle.
 *
 * The only thing the garage's facets are made of, and it lives in the filter
 * sheet (`GarageFilterSheet`). It was briefly drawn inline above the grid as
 * well — two agents building the same screen each shipped a filter UI — and the
 * inline one lost: four facet groups of up to five options each filled the
 * whole fold on a 13 mini, so the catalogue opened on a wall of controls and no
 * car. On an illustration-led product the fold belongs to the artwork.
 *
 * WHAT A PILL SAYS is `aria-pressed`, not its colour. A row of toggles told
 * apart only by an orange tint is a row nobody using a screen reader can read
 * and one somebody with a colour deficiency has to guess at — so the state is in
 * the markup, the tick is in the pixels, and the tint is the third carrier
 * rather than the only one (NFR-04).
 */
export default function FacetPill({ label, isActive, onToggle }) {
    return (
        <button
            type="button"
            className={`facet-pill${isActive ? ' facet-pill--active' : ''}`}
            onClick={onToggle}
            aria-pressed={isActive}
        >
            {/* Always in the document, so turning a pill on does not change its
                width and shuffle the ones beside it along the row. */}
            <CheckIcon className="facet-pill__tick" size={14} />
            <span className="facet-pill__label">{label}</span>
        </button>
    );
}
